import { Configuration } from '@azure/msal-browser'
import { LogLevel } from '@azure/msal-browser'
const ep = process.env.VUE_APP_APILINK
const sr = [process.env.VUE_APP_BACKENDSCOPEURLREAD]
const sw = [process.env.VUE_APP_BACKENDSCOPEURLREADWRITE]

export const scopes = [
  ...sr,
  ...sw
]

const tenantAId = process.env.VUE_APP_TENANTID

//for each of the uris, use the generic one stored in the .env files. This way, the endpoint will change depending on the state.
const cidd = process.env.VUE_APP_FRONTENDCID // This is the ONLY mandatory field that you need to supply.
let authh = 'https://'+process.env.VUE_APP_TENANTNAMENOTDISPLAYNAME+'.ciamlogin.com' // Replace the placeholder with your tenant name newer method esp for external users
//alert(authh)
authh = "https://login.microsoftonline.com/"+process.env.VUE_APP_TENANTID //internal apps relying on Azure AD - older
//authh = "https://login.microsoftonline.com/"+"3ec46817-dd2c-4776-b224-7108c4ef9fa8"
//alert(authh)
//alert(1/0)
//const rduri = `${location.origin}/auth/redirect/login`
const rduri = process.env.VUE_APP_FRONTENDROOT // You must register this URI on Azure Portal/App Registration. Defaults to window.location.href e.g. http://localhost:3000/,
const prduri = process.env.VUE_APP_FRONTENDWELCOME // Indicates the page to navigate after logout.


export const config = {
  // required
  auth: {
    // must match info in dashboard
    clientId: cidd,
    authority: authh,


    // login redirect; must match path in dashboard
    redirectUri: rduri,
  //   validateAuthority: true,
  //      knownAuthorities: [
  //    `login.microsoftonline.com/${tenantAId}`,
  //  ],
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, 
                // but "localStorage" gives you SSO. and when you "open an endpoint in a new tab" - it will be logged in. So for better user experience, we are using localStorage.
        storeAuthStateInCookie: false, // set this to true if you have to support IE
    },
  },

  // optional
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      loggerCallback,
    }
  }
}

function loggerCallback (level, message, containsPii) {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.warn(message);
                        return;
                }
}


function loggerCallback1 (level, message, containsPi) {
  if (!containsPii) {
    const parts = message.split(' : ')
    const text = parts.pop()
    switch (level) {
      case LogLevel.Error:
        return console.error(text)

      case LogLevel.Warning:
        return console.warn(text)

      case LogLevel.Info:
        return console.info(text)

      case LogLevel.Verbose:
        return console.debug(text)
    }
  }
}
